import { deleteQuestion } from '@/api/api';

export default {
  methods: {
    async onDelete(index) {
      if (this.questions[index].uuid) {
        await deleteQuestion(this.questions[index].uuid);
      }
      this.questions.splice(index, 1);
    },
    onNew() {
      this.questions.push(this.defaultQuestion());
    },
  },
};
